import { initDropdowns } from '../dropdowns/lib';
import { MODAL_CLOSE_EVENT, MODAL_LOAD_EVENT } from '../dialogs/lib';
import addSelectDropdowns from '../dropdowns/select';
import analytics from '../../analytics';
var PositionType;
(function (PositionType) {
    PositionType["HEART"] = "heart";
    PositionType["RIGHT"] = "right";
    PositionType["LEFT_SLEEVE"] = "left_sleeve";
    PositionType["RIGHT_SLEEVE"] = "right_sleeve";
})(PositionType || (PositionType = {}));
const formatCharacters = (characters, symbols) => {
    let value = '';
    for (let i = 0; i < characters.length; i += 1) {
        if (symbols.includes(characters[i])) {
            value += `<span class="c-preview-customisation__symbol">${characters[i]}</span>`;
        }
        else {
            value += characters[i];
        }
    }
    return value;
};
export default function updateCustomisations() {
    document.querySelectorAll('[data-ajax-modal]').forEach((dialog) => {
        dialog.addEventListener(MODAL_LOAD_EVENT, (e) => {
            if (e.detail.role === 'customisation') {
                const tracking = JSON.parse(dialog.querySelector('[data-tracking]').dataset.tracking);
                analytics.productCustomisationViewed(tracking);
                initDropdowns();
                addSelectDropdowns();
                // Sync message with photo preview if media exist
                const form = dialog.querySelector('form');
                const elements = form.elements;
                const textInputs = form.querySelectorAll('[name="customizations[]"]');
                const symbolInputs = form.querySelectorAll('.c-product-symbols__label');
                const symbols = Array.from(form.querySelectorAll('[name="symbol"]')).map((input) => input.value);
                const color = elements.color;
                const isPreviewable = form.querySelector('#isPreviewable');
                const position = elements.position;
                const preview = dialog.querySelector('[data-customisation-text]');
                const button = form.querySelector('#addToCartCustomProductButton');
                let lastFocus = form.querySelector('[name="customizations[]"]');
                let caretPos = 0;
                const onInput = () => {
                    let textContent = '';
                    textInputs.forEach((textInput) => {
                        if (textInput.value !== '') {
                            textContent += `${formatCharacters(textInput.value, symbols)}<br />`;
                        }
                    });
                    if (textContent.length === 0) {
                        button.setAttribute('disabled', 'disabled');
                    }
                    else {
                        button.removeAttribute('disabled');
                    }
                    if (preview && isPreviewable?.checked) {
                        preview.innerHTML = textContent;
                        if (color) {
                            const selectedNode = Array.from(color).find((node) => node.checked);
                            preview.style.color = selectedNode.dataset.color;
                        }
                        if (position) {
                            if (position.value === PositionType.HEART) {
                                preview.style.top = '36%';
                                preview.style.left = '55%';
                                preview.style.right = 'auto';
                            }
                            else if (position.value === PositionType.RIGHT) {
                                preview.style.top = '36%';
                                preview.style.left = 'auto';
                                preview.style.right = '55%';
                            }
                            else {
                                // Temporarily hide preview when position is not heart/right (cf. https://sezane.atlassian.net/browse/SEZANE-7193)
                                preview.style.display = 'none';
                            }
                        }
                    }
                };
                const addSymbol = (addSymbolEvent) => {
                    const originalText = lastFocus.value;
                    if (originalText.length >= lastFocus.maxLength) {
                        return;
                    }
                    const begin = originalText.substring(0, caretPos);
                    const end = originalText.substring(caretPos, originalText.length);
                    lastFocus.value = begin + addSymbolEvent.currentTarget.innerText + end;
                    onInput();
                    caretPos += 1;
                };
                const updateLastFocus = (updateLastFocusEvent) => {
                    lastFocus = updateLastFocusEvent.currentTarget;
                    caretPos = lastFocus.selectionStart;
                };
                textInputs.forEach((textInput) => {
                    textInput.addEventListener('blur', updateLastFocus);
                });
                symbolInputs.forEach((symbolInput) => {
                    symbolInput.addEventListener('click', addSymbol);
                });
                form.addEventListener('input', onInput);
                onInput();
            }
        });
        dialog.addEventListener(MODAL_CLOSE_EVENT, (e) => {
            if (e.detail.role === 'customisation') {
                const tracking = JSON.parse(dialog.querySelector('[data-tracking]').dataset.tracking);
                analytics.productCustomisationClosed(tracking);
            }
        });
    });
}
